import type { ObjectId } from 'mongoose';

export enum TTXExerciseTypeEnum {
  QUICK = 'quick',
  FULL = 'full',
}

export interface TTXTemplatePhase {
  phaseId: string;
  isLastPhase: boolean;
}

export interface TTXTemplateStage {
  stageId: string;
  isLastStage: boolean;
  phases: TTXTemplatePhase[];
}

export interface TTXCreateTemplateBody {
  code: string;
  name: string;
  description: string;
  totalSteps: number;
  maxScore: number;
  minScore: number;
  exerciseType: TTXExerciseTypeEnum;
  stages: TTXTemplateStage[];
  stageStartingSteps: number[];
  stepsPerStage: number[];
  stageSteps: Record<number, number[]>;
  stepToPhaseMap: Record<number, number>;
}

export type TTXUpdateTemplateBody = Partial<TTXCreateTemplateBody>;

export interface TTXTemplate extends TTXCreateTemplateBody {
  readonly _id: string;
  readonly createdBy: ObjectId;
  readonly updatedBy: ObjectId;
  readonly createdAt: Date;
  readonly updatedAt: Date;
}

export type TTXTemplateDocument = TTXTemplate;
